import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Divider,
  Grid,
  Typography,
  Box,
  useTheme,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";
import { Link, useHistory } from "react-router-dom";
import { Field, reduxForm, getFormSyncErrors, getFormValues } from "redux-form";
import { renderTextField } from "components/FormFields/FieldTypes";
import { phone as phoneFormatter } from "components/FormFields/formatters";
import { phone as phoneNormalizer } from "components/FormFields/normalizers";
import {
  emailValidator,
  phone as phoneValidator,
} from "components/FormFields/validators";
import { homeActions } from "actions";

const ForgotPassword = (props) => {
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  const history = useHistory();
  const {
    formValues,
    initialize,
    formErrors,
    forgotLoginPasswordInfo,
    loginForgotPassword,
    loginForgotParams,
    forgotLoginPasswordStatus,
    resetLoginForgotPasswordStatus,
  } = props;
  const [showSuccess, setShowSuccess] = useState(false);

  const onFormSubmit = () => {
    loginForgotPassword(formValues);
  };

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    if (loginForgotParams) {
      initialize({
        phone: loginForgotParams?.phone || "",
        email: loginForgotParams?.email || "",
      });
    }
    return () => {
      resetLoginForgotPasswordStatus();
    };
  }, []);

  useEffect(() => {
    if (forgotLoginPasswordStatus || forgotLoginPasswordStatus === false) {
      setShowSuccess(true);
    }
  }, [forgotLoginPasswordStatus]);

  return (
    <SecondaryCenterTemplate pageTitle="Forgot Password">
      <Grid container>
        <Grid item sm={8} xs={12} sx={{ margin: "auto" }}>
          <Box>
            <Box mb={6} mt={matchesSm ? 0 : 5} sx={{ textAlign: "center" }}>
              <Typography
                variant="h3LatoBlack"
                sx={{ fontSize: matchesMinWidth ? undefined : "24px" }}
              >
                Please enter your sign up information
              </Typography>
            </Box>
            <form>
              <Grid item container alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                  <Field
                    name="phone"
                    isRequired
                    component={renderTextField}
                    label="Mobile phone number"
                    format={phoneFormatter}
                    validate={[phoneValidator]}
                    normalize={phoneNormalizer}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box mb={3} mt={5}>
                    <Divider
                      sx={{
                        "&:before": {
                          borderColor: theme.palette.primary.main,
                        },
                        "&:after": {
                          borderColor: theme.palette.primary.main,
                        },
                      }}
                    >
                      <Typography variant="text3">OR</Typography>
                    </Divider>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    name="email"
                    isRequired
                    component={renderTextField}
                    label="Email Address"
                    validate={[emailValidator]}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{
                    margin: "auto",
                    marginTop: "80px",
                    marginBottom: "24px",
                    textAlign: "center",
                  }}
                >
                  <Box>
                    <Typography variant="h4LatoRegular">
                      By continuing to use this website, you agree to the
                      Cuverd®
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="h4LatoRegular"
                      sx={{ color: theme.palette.common.greenThree }}
                      component={Link}
                      to="/terms-and-conditions"
                    >
                      Terms and Conditions
                    </Typography>
                    <Typography variant="h4LatoRegular">
                      &nbsp;and&nbsp;
                    </Typography>
                    <Typography
                      variant="h4LatoRegular"
                      component={Link}
                      to="/privacy-policy"
                      sx={{ color: theme.palette.common.greenThree }}
                    >
                      Privacy Policy
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{
                    margin: "auto",
                    textAlign: "center",
                    marginBottom: { xs: "20px", sm: "20px", md: "80px" },
                  }}
                >
                  <Button
                    variant="large"
                    type="button"
                    onClick={() => onFormSubmit()}
                    disabled={Object.keys(formErrors).length ? true : false}
                    sx={{
                      minWidth: { xs: "100%", sm: "100%", md: undefined },
                      fontSize: matchesSm ? "18px" : undefined,
                      backgroundColor:
                        !formValues || Object.keys(formErrors).length
                          ? "#e6e6e6"
                          : undefined,
                      color:
                        !formValues || Object.keys(formErrors).length
                          ? "#637276"
                          : undefined,
                      boxShadow: "none",
                    }}
                  >
                    SEND TEMPORARY PASSWORD
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
          {showSuccess ? (
            <Dialog open={showSuccess} className="info-dialog">
              <DialogContent sx={{ padding: "40px" }}>
                {forgotLoginPasswordInfo && forgotLoginPasswordInfo.success ? (
                  <Box>
                    <Box mt={1}>
                      <Typography variant="h3LatoRegular">
                        A temporary password has been sent to:
                      </Typography>
                    </Box>
                    <Box mt={2}>
                      <Typography variant="h1LatoHeavy">
                        {formValues &&
                          (formValues.email ||
                            phoneFormatter(formValues.phone))}
                      </Typography>
                    </Box>
                    <Box sx={{ paddingTop: "80px" }}>
                      <Typography variant="h3LatoRegular">
                        Please use it to continue signing in
                      </Typography>
                    </Box>
                    <Box mt={3} mb={3}>
                      <Button
                        variant="large"
                        onClick={() => {
                          history.push("/ForgotVerifyPassword");
                          setShowSuccess(false);
                        }}
                        sx={{ minWidth: { xs: "150px" }, width: "100%" }}
                      >
                        SIGN IN
                      </Button>
                    </Box>
                  </Box>
                ) : null}
                {forgotLoginPasswordInfo &&
                !forgotLoginPasswordInfo.success &&
                forgotLoginPasswordInfo.message ? (
                  <Box>
                    <Box mt={2} mb={3}>
                      <Typography variant="text4">
                        {forgotLoginPasswordInfo.message}
                      </Typography>
                    </Box>
                    <Box mt={3}>
                      <Button
                        variant="large"
                        onClick={() => setShowSuccess(false)}
                        sx={{
                          minWidth: { xs: "150px", sm: "150px", md: undefined },
                        }}
                      >
                        DONE
                      </Button>
                    </Box>
                  </Box>
                ) : null}
              </DialogContent>
            </Dialog>
          ) : null}
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("FORGOT_PASSWORD_FORM")(state) || {},
    formValues: getFormValues("FORGOT_PASSWORD_FORM")(state),
    forgotLoginPasswordInfo: state.forgotLoginPassword.data,
    forgotLoginPasswordStatus: state.forgotLoginPassword.isSuccess,
    loginForgotParams: state.forgotLoginPassword.loginForgotParams,
    resendForgotLoginPasswordInfo: state.resendForgotLoginPassword.data,
    verifyForgotLoginPasswordInfo: state.verifyForgotLoginPassword.data,
  };
};

const mapDispatchToProps = {
  loginForgotPassword: (params) => homeActions.loginForgotPassword(params),
  loginResendForgotPassword: (params) =>
    homeActions.loginResendForgotPassword(params),
  loginVerifyForgotPassword: (params) =>
    homeActions.loginVerifyForgotPassword(params),
  resetAccountChangeData: () => homeActions.resetAccountChangeData(),
  resetLoginForgotPasswordStatus: () =>
    homeActions.resetLoginForgotPasswordStatus(),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "FORGOT_PASSWORD_FORM",
  })(ForgotPassword)
);
